import type { SupportedLanguage } from "../../interfaces";

/**
 * The heading printed on the Top Sessions card and at the top of the Top
 * Sessions page.
 *
 * The admin authors it per language (`cardTitle`), in which case it is printed
 * verbatim. Spaces that never authored one keep the app's own label — composed
 * here, and explicitly resolved in the CONTENT language: the heading titles a
 * language-scoped list of sessions, so it must flip with the reader's content
 * toggle, not with the interface language.
 *
 * The `{ lng }` here was correct from the start and did not WORK until the
 * content-language bundle was preloaded in `setRoomContentLang` — i18next loads
 * locale bundles lazily, so naming a language it has not fetched falls through to
 * English, intermittently, depending on what the localStorage cache happened to
 * hold. Do not "simplify" this to a bare `t()`; do not remove the preload.
 */
export function resolveTopSessionsHeading({
  cardTitle,
  shortName,
  sessionCount,
  contentLang,
  t,
}: {
  cardTitle: string | null;
  shortName: string;
  sessionCount: number;
  contentLang: SupportedLanguage;
  t: (key: string, options: { count: number; lng: string }) => string;
}): string {
  if (cardTitle !== null) return cardTitle;
  return `${shortName} ${t("Top {{count}} must-see sessions", {
    count: sessionCount,
    lng: contentLang,
  })}`;
}
